import { render } from "./TeamingChip2.vue?vue&type=template&id=0d8cf076&scoped=true"
import script from "./TeamingChip2.vue?vue&type=script&lang=js"
export * from "./TeamingChip2.vue?vue&type=script&lang=js"

import "./TeamingChip2.vue?vue&type=style&index=0&id=0d8cf076&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d8cf076"

export default script